import React from 'react';

const LaunchIcon = ({ color = '#90909E', width = 14, height = 14 }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
  >
    <path
      d="M10.5 11.0833H3.5C3.17917 11.0833 2.91667 10.8208 2.91667 10.5V3.5C2.91667 3.17917 3.17917 2.91667 3.5 2.91667H6.41667C6.7375 2.91667 7 2.65417 7 2.33333C7 2.0125 6.7375 1.75 6.41667 1.75H2.91667C2.26917 1.75 1.75 2.275 1.75 2.91667V11.0833C1.75 11.725 2.275 12.25 2.91667 12.25H11.0833C11.725 12.25 12.25 11.725 12.25 11.0833V7.58333C12.25 7.2625 11.9875 7 11.6667 7C11.3458 7 11.0833 7.2625 11.0833 7.58333V10.5C11.0833 10.8208 10.8208 11.0833 10.5 11.0833ZM8.16667 2.33333C8.16667 2.65417 8.42917 2.91667 8.75 2.91667H10.2608L4.935 8.2425C4.7075 8.47 4.7075 8.8375 4.935 9.065C5.1625 9.2925 5.53 9.2925 5.7575 9.065L11.0833 3.73917V5.25C11.0833 5.57083 11.3458 5.83333 11.6667 5.83333C11.9875 5.83333 12.25 5.57083 12.25 5.25V1.75H8.75C8.42917 1.75 8.16667 2.0125 8.16667 2.33333Z"
      fill={color}
    />
  </svg>
);

export default LaunchIcon;
